<oui-autocomplete
  #autocomplete
  [label]="label"
  [control]="control"
  [options]="autocompleteOptions"
  [allowCustomValue]="true"
  [displayOptionsOnEmptySearch]="false"
  [displayResetButton]="true"
  [isLoading]="isLoading"
  class="width-100pc"></oui-autocomplete>
